/**
 * Espera as imagens de um trecho do DOM carregarem e decodificarem antes
 * de imprimir/gerar PDF — senão a folha sai com buracos no lugar das fotos.
 * Nunca trava a impressão: imagem quebrada conta como pronta e há um teto
 * de tempo (`timeoutMs`).
 */
export async function aguardarImagensCarregadas(
  raiz: ParentNode | null | undefined,
  timeoutMs = 5000,
): Promise<void> {
  if (!raiz) return;
  const imagens = Array.from(raiz.querySelectorAll('img'));
  if (imagens.length === 0) return;

  const prontas = imagens.map((img) => {
    const carregou: Promise<void> = img.complete
      ? Promise.resolve()
      : new Promise<void>((resolve) => {
          img.addEventListener('load', () => resolve(), { once: true });
          img.addEventListener('error', () => resolve(), { once: true });
        });
    return carregou.then(() =>
      img.naturalWidth > 0 && typeof img.decode === 'function'
        ? img.decode().catch(() => undefined)
        : undefined,
    );
  });

  let timer: ReturnType<typeof setTimeout> | undefined;
  await Promise.race([
    Promise.all(prontas),
    new Promise<void>((resolve) => {
      timer = setTimeout(resolve, timeoutMs);
    }),
  ]);
  if (timer) clearTimeout(timer);
}
